
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { APP_CONFIG } from './app/models/constants';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

// MSAL v5 returns popup, silent (iframe) and redirect auth responses to redirectUri, which must run the redirect bridge.
function hasAuthResponseInUrl(): boolean {
  const candidates = [window.location.hash.replace(/^#\/?/, ''), window.location.search.replace(/^\?/, '')];
  return candidates.some(value => {
    const params = new URLSearchParams(value);
    return params.has('state') && (params.has('code') || params.has('error'));
  });
}

async function main() {
  if (hasAuthResponseInUrl()) {
    const originalTitle = document.title;
    try {
      await broadcastResponseToMainFrame();
      return;
    } catch (error) {
      document.title = originalTitle;
      console.error('MSAL redirect bridge failed, continuing with app bootstrap', error);
    }
  }
  try {
    const data = await fetch('/assets/config/ui-config.json');
    const config = await data.json();

    if (environment.production) {
      enableProdMode();
    }
    await platformBrowserDynamic([
      { provide: APP_CONFIG, useValue: config },
    ]).bootstrapModule(AppModule, {
      // Angular v21+ bootstraps NgModules zoneless by default; this app relies on zone.js-driven change detection.
      applicationProviders: [provideZoneChangeDetection()]
    })
      .catch(error => console.error('Got an error while setting up Main.ts', error));
  } catch (error) {
    console.error('Got an error while fetching Config file', error);
  }
}
main();